// CONSTANTS are all caps.
const NS = 'SimpleLocationSearchContainer';
const CLS = 'simpleLocationSearchContainer';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import queryString from 'global/js/query-string.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { utils } from '../../../../global/js/utils.js';
import rSimpleLocationSearchContainer from './SimpleLocationSearchContainer.jsx';

export class SimpleLocationSearchContainer {
  constructor($el) {
    // $el is the blk node return by the loadSimpleLocationSearchContainer function
    this.$el = $el;
    this.parkinglocationApi = $(this.$el).data('api');
    this.ctaText = $(this.$el).data('ctatext');
    this.zoom = $(this.$el).data('zoom');
    this.type = $(this.$el).data('type');
    this.pageid = $(this.$el).data('pageid');

    this.lat = $(this.$el).data('lat');
    this.lng = $(this.$el).data('lng');
    this.address = $(this.$el).data('address');
    // this is google pos from navigator
    // this.userLocationPos = {};
    this.stayLongerText = $(this.$el).data('staylongertext');
    this.stayLongerUrl = $(this.$el).data('staylongerurl');
    this.carparkfeature = $(this.$el).data('carparkfeature');
    this.ctatarget = $(this.$el).data('ctatarget');
    this.country = $(this.$el).data('country');

    // book online
    console.log(this.$el.dataset);
    this.states = JSON.parse(this.$el.dataset.states);
    this.bookonlineTitle = this.$el.dataset.bookonlineTitle;
    this.autocompleteApi = this.$el.dataset.autocompleteApi;
    this.bookonlineDesc = this.$el.dataset.bookonlineDesc;
    this.mainTitle = this.$el.dataset.mainTitle;
    this.bookonlinePlaceholder = this.$el.dataset.bookonlinePlaceholder;
    this.bookonlineWheretofind = this.$el.dataset.bookonlineWheretofind;
    // recommended parking feature
    this.recommendedParkingFeature = $(this.$el).data(
      'recommendedparkingfeature'
    );
    this.recommendedParkingApi = $(this.$el).data('recommendedparkingapi');
    this.recommendedParkingCtaText = $(this.$el).data(
      'recommendedparkingctatext'
    );
    this.recommendedParkingBgColor = $(this.$el).data(
      'recommendedparkingbgcolor'
    );
    this.iconBookOnline = this.$el.dataset.iconBookOnline;
    this.iconMonthlyParking = this.$el.dataset.iconMonthlyParking;
    this.iconParkingCard = this.$el.dataset.iconParkingCard;
    this.iconEvCharger = this.$el.dataset.iconEvCharger;
    this.iconLabelBookOnline = this.$el.dataset.iconLabelBookOnline;
    this.iconLabelMonthlyParking = this.$el.dataset.iconLabelMonthlyParking;
    this.iconLabelParkingCard = this.$el.dataset.iconLabelParkingCard;
    this.iconLabelEvCharger = this.$el.dataset.iconLabelEvCharger;
    this.cpms = this.$el.dataset.cpms;
    this.submitButtonLabel = this.$el.dataset.submitButtonLabel;
    this.bookABayUrl = this.$el.dataset.bookABayUrl;
  }

  init() {
    // const parsedQuery = queryString.parse(location.search);

    // if(!parsedQuery.address) {
    // 	window.history.replaceState('', '', utils.updateURLParameter(window.location.href, 'address', this.address));
    // }

    const parsedQuery = utils.getLocationFromStorage();

    if (parsedQuery.lat && parsedQuery.lng) {
      // if it has defined the destination in home page
      // use this destination
      let destination = {
        lat: Number(parsedQuery.lat),
        lng: Number(parsedQuery.lng),
        distance: 20,
      };

      // Add Some logic here
      this.updateQueryBinding(destination);
      this.setSimpleLocationSearchContainer(destination);
      return;
    } else if (this.lat && this.lng) {
      let destination = {
        lat: Number(this.lat),
        lng: Number(this.lng),
        distance: 20,
      };
      // Add Some logic here
      this.updateQueryBinding(destination);
      this.setSimpleLocationSearchContainer(destination);
      return;
    }

    this.setSimpleLocationSearchContainer();
  }

  setSimpleLocationSearchContainer(destination) {
    console.log(destination);
    if (destination && destination.lat && destination.lng) {
      const defaultProps = {
        destination: {
          lat: destination.lat,
          lng: destination.lng,
          distance: 20,
        },
        userLocationPos: {},
        api: this.parkinglocationApi,
        ctaText: this.ctaText,
        type: this.type,
        zoom: this.zoom,
        country: this.country,

        pageid: this.pageid,
        stayLongerText: this.stayLongerText,
        stayLongerUrl: this.stayLongerUrl,
        carparkfeature: this.carparkfeature,

        states: this.states,
        mainTitle: this.mainTitle,
        ctatarget: this.ctatarget,

        bookonlineTitle: this.bookonlineTitle,
        bookonlinePlaceholder: this.bookonlinePlaceholder,
        bookonlineWheretofind: this.bookonlineWheretofind,
        bookonlineDesc: this.bookonlineDesc,
        autocompleteApi: this.autocompleteApi,

        recommendedParkingFeature: this.recommendedParkingFeature,
        recommendedParkingApi: this.recommendedParkingApi,
        recommendedParkingCtaText: this.recommendedParkingCtaText,
        recommendedParkingBgColor: this.recommendedParkingBgColor,
        iconBookOnline: this.iconBookOnline,
        iconMonthlyParking: this.iconMonthlyParking,
        iconParkingCard: this.iconParkingCard,
        iconEvCharger: this.iconEvCharger,
        iconLabelBookOnline: this.iconLabelBookOnline,
        iconLabelMonthlyParking: this.iconLabelMonthlyParking,
        iconLabelParkingCard: this.iconLabelParkingCard,
        iconLabelEvCharger: this.iconLabelEvCharger,
        cpms: this.cpms,
        submitButtonLabel: this.submitButtonLabel,
        bookABayUrl: this.bookABayUrl,
      };

      this.updateQueryBinding(defaultProps.destination);
      ReactDOM.render(
        React.createElement(rSimpleLocationSearchContainer, defaultProps),
        this.$el
      );
      return;
    }

    // if destination undefined, use current location
    if (navigator.geolocation) {
      console.log(navigator.geolocation);

      navigator.geolocation.getCurrentPosition(
        // successful callback
        (pos) => {
          const defaultProps = {
            destination: {
              lat: destination ? destination.lat : pos.coords.latitude,
              lng: destination ? destination.lng : pos.coords.longitude,
              distance: 20,
            },
            userLocationPos: pos,
            api: this.parkinglocationApi,
            ctaText: this.ctaText,
            country: this.country,

            zoom: this.zoom,
            pageid: this.pageid,
            type: this.type,
            stayLongerText: this.stayLongerText,
            stayLongerUrl: this.stayLongerUrl,
            carparkfeature: this.carparkfeature,
            mainTitle: this.mainTitle,
            ctatarget: this.ctatarget,

            states: this.states,
            bookonlineTitle: this.bookonlineTitle,
            bookonlineDesc: this.bookonlineDesc,
            autocompleteApi: this.autocompleteApi,
            bookonlinePlaceholder: this.bookonlinePlaceholder,
            bookonlineWheretofind: this.bookonlineWheretofind,

            recommendedParkingFeature: this.recommendedParkingFeature,
            recommendedParkingApi: this.recommendedParkingApi,
            recommendedParkingCtaText: this.recommendedParkingCtaText,
            recommendedParkingBgColor: this.recommendedParkingBgColor,
            iconBookOnline: this.iconBookOnline,
            iconMonthlyParking: this.iconMonthlyParking,
            iconParkingCard: this.iconParkingCard,
            iconEvCharger: this.iconEvCharger,
            iconLabelBookOnline: this.iconLabelBookOnline,
            iconLabelMonthlyParking: this.iconLabelMonthlyParking,
            iconLabelParkingCard: this.iconLabelParkingCard,
            iconLabelEvCharger: this.iconLabelEvCharger,
            cpms: this.cpms,
            submitButtonLabel: this.submitButtonLabel,
            bookABayUrl: this.bookABayUrl,
          };

          const _location =
            queryString.parse(localStorage.getItem('userLocation')) || {};
          _location['lat'] = defaultProps.destination.lat;
          _location['lng'] = defaultProps.destination.lat;
          localStorage.setItem('userLocation', $.param(_location));

          this.updateQueryBinding(defaultProps.destination);
          ReactDOM.render(
            React.createElement(rSimpleLocationSearchContainer, defaultProps),
            this.$el
          );
        },
        // error callback
        () => {
          const defaultProps = {
            destination: {
              // default central au
              lat: destination ? destination.lat : -23,
              lng: destination ? destination.lng : 133,
              distance: 20,
            },
            userLocationPos: {},
            api: this.parkinglocationApi,
            ctaText: this.ctaText,
            type: this.type,
            stayLongerText: this.stayLongerText,
            stayLongerUrl: this.stayLongerUrl,
            // parkinZoomApi: this.parkinZoomApi,
            // showEntryExitTimes: this.showEntryExitTimes,
            country: this.country,
            zoom: this.zoom,
            pageid: this.pageid,
            carparkfeature: this.carparkfeature,
            mainTitle: this.mainTitle,
            ctatarget: this.ctatarget,

            states: this.states,
            bookonlineTitle: this.bookonlineTitle,
            bookonlinePlaceholder: this.bookonlinePlaceholder,
            bookonlineWheretofind: this.bookonlineWheretofind,
            bookonlineDesc: this.bookonlineDesc,
            autocompleteApi: this.autocompleteApi,
            // limitFilters: this.limitFilters,

            recommendedParkingFeature: this.recommendedParkingFeature,
            recommendedParkingApi: this.recommendedParkingApi,
            recommendedParkingCtaText: this.recommendedParkingCtaText,
            recommendedParkingBgColor: this.recommendedParkingBgColor,
            iconBookOnline: this.iconBookOnline,
            iconMonthlyParking: this.iconMonthlyParking,
            iconParkingCard: this.iconParkingCard,
            iconEvCharger: this.iconEvCharger,
            iconLabelBookOnline: this.iconLabelBookOnline,
            iconLabelMonthlyParking: this.iconLabelMonthlyParking,
            iconLabelParkingCard: this.iconLabelParkingCard,
            iconLabelEvCharger: this.iconLabelEvCharger,
            cpms: this.cpms,
            submitButtonLabel: this.submitButtonLabel,
            bookABayUrl: this.bookABayUrl,
          };

          const _location =
            queryString.parse(localStorage.getItem('userLocation')) || {};
          _location['lat'] = defaultProps.destination.lat;
          _location['lng'] = defaultProps.destination.lat;
          localStorage.setItem('userLocation', $.param(_location));

          this.updateQueryBinding(defaultProps.destination);
          ReactDOM.render(
            React.createElement(rSimpleLocationSearchContainer, defaultProps),
            this.$el
          );
        }
      );
    } else {
      console.err('Geolocation is not supported by this browser.');
    }
  }

  updateQueryBinding(location) {
    // window.history.replaceState('', '', utils.updateURLParameter(window.location.href, 'lat', location.lat));
    // window.history.replaceState('', '', utils.updateURLParameter(window.location.href, 'lng', location.lng));
  }
  // Add more functions like on above here
}
